import { render, staticRenderFns } from "./OrderRegisterForm.vue?vue&type=template&id=6ca7bf3a&"
import script from "./OrderRegisterForm.vue?vue&type=script&lang=js&"
export * from "./OrderRegisterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports